<template>
  <span>
    ({{ getNumOfMatches }})
  </span>
</template>

<script>
export default {
  name: 'FilterMatches',
  props: {
    filter: {
      type: String,
      default: ''
    }
  },

  computed: {
    getNumOfMatches () {
      return this.$store.getters['results/getNumOfMatches'](this.filter)
    }
  }
}
</script>
